__turbopack_context__.v({
  "brandBlock": "login-module__MevKGq__brandBlock",
  "fallbackStack": "login-module__MevKGq__fallbackStack",
  "formBlock": "login-module__MevKGq__formBlock",
  "headline": "login-module__MevKGq__headline",
  "inner": "login-module__MevKGq__inner",
  "inviteHint": "login-module__MevKGq__inviteHint",
  "logoImg": "login-module__MevKGq__logoImg",
  "logoWrap": "login-module__MevKGq__logoWrap",
  "shell": "login-module__MevKGq__shell",
});
